import Sprite from "../object-graphics/Sprite";
import PixelNumber from "../object-graphics/PixelNumber";
import { PLACEMENT_TYPE_CHIP } from "../../helpers/consts";
import { TILES } from "../../helpers/tiles";
import styles from "./FlourCount.module.css";

export default function FlourCount({ level }) {
  const flourRemaining = level.placements.filter(
    (p) => p.type === PLACEMENT_TYPE_CHIP && !p.hasBeenCollected
  ).length;
  return (
    <div className={styles.flourCount}>
      <Sprite frameCoord={TILES.FLOUR} />
      <PixelNumber number={flourRemaining} />
    </div>
  );
}
